export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6847.34d0511b.jpg";